import React, { useState } from 'react';

function ApiDocs({ onBack }) {
  const [selectedEndpoint, setSelectedEndpoint] = useState(null);
  const [activeProduct, setActiveProduct] = useState('xharelyPOS');

  const publicEndpoints = [
    {
      method: 'POST',
      path: '/api/register',
      title: 'Register Merchant & Toko',
      description: 'Daftarkan merchant baru beserta akun owner toko pertama kali.',
      auth: 'Public (No Auth Required)',
      params: {
        merchant_name: 'string (required) - Nama usaha/toko',
        merchant_email: 'string (required) - Email resmi toko',
        merchant_phone: 'string (required) - Nomor telepon toko',
        merchant_address: 'string (required) - Alamat toko',
        name: 'string (required) - Nama lengkap pemilik',
        email: 'string (required) - Email akun owner',
        password: 'string (required) - Minimal 6 karakter',
        password_confirmation: 'string (required)'
      },
      response: {
        status: 'success',
        message: 'Registration successful. Please check your email to verify your account.',
        merchant: { id: 'uuid-1', name: 'Kopi Kenangan Senja', code: 'MRC123' },
        user: { id: 'uuid-2', name: 'Budi Santoso', email: 'budi@kopisenja.com', role: 'owner' }
      }
    },
    {
      method: 'POST',
      path: '/api/login',
      title: 'Login & Obtain JWT Token',
      description: 'Autentikasi akun kasir/owner untuk mendapatkan JWT Bearer Token.',
      auth: 'Public (No Auth Required)',
      params: {
        email: 'string (required) - Email terdaftar',
        password: 'string (required) - Kata sandi'
      },
      response: {
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
        token_type: 'Bearer',
        user: {
          id: 'uuid-2',
          name: 'Budi Santoso',
          email: 'budi@kopisenja.com',
          role: 'owner',
          merchant_id: 'uuid-1',
          outlet_id: 'uuid-outlet-1'
        }
      }
    },
    {
      method: 'POST',
      path: '/api/forgot-password',
      title: 'Request Reset Password',
      description: 'Kirimkan tautan reset password aman ke alamat email terdaftar.',
      auth: 'Public (No Auth Required)',
      params: {
        email: 'string (required) - Email akun'
      },
      response: {
        status: 'success',
        message: 'Tautan reset password telah dikirim ke email Anda. Silakan cek inbox/spam email.'
      }
    },
    {
      method: 'POST',
      path: '/api/reset-password',
      title: 'Submit New Password',
      description: 'Perbarui kata sandi dengan token valid yang diterima via email.',
      auth: 'Public (No Auth Required)',
      params: {
        email: 'string (required)',
        token: 'string (required) - Token dari email',
        password: 'string (required) - Minimal 6 karakter',
        password_confirmation: 'string (required)'
      },
      response: {
        status: 'success',
        message: 'Password berhasil diperbarui! Silakan login dengan password baru.'
      }
    },
    {
      method: 'GET',
      path: '/api/subscription/plans',
      title: 'Get Official Subscription Plans',
      description: 'Dapatkan daftar paket langganan resmi (PRO & BISNIS) dan harga promo aktif.',
      auth: 'Public (No Auth Required)',
      response: {
        status: 'success',
        plans: [
          { code: 'pro_1m', name: 'Paket PRO - 1 Bulan', price: 119000, months: 1, plan_type: 'pro' },
          { code: 'pro_12m', name: 'Paket PRO - 12 Bulan', price: 1099000, months: 12, plan_type: 'pro', is_popular: true },
          { code: 'biz_1m', name: 'Paket BISNIS - 1 Bulan', price: 299000, months: 1, plan_type: 'business' }
        ]
      }
    },
    {
      method: 'GET',
      path: '/api/receipt/{transaction}',
      title: 'Public Digital Receipt Preview',
      description: 'Tampilan preview struk transaksi digital pelanggan via browser.',
      auth: 'Public (No Auth Required)',
      response: {
        invoice: 'TRX-260818-001',
        merchant_name: 'Kopi Kenangan Senja',
        total: 94350,
        status: 'PAID',
        date: '2026-08-18T10:30:00Z'
      }
    },
    {
      method: 'GET',
      path: '/api/health',
      title: 'System Health Check',
      description: 'Periksa status ketersediaan API backend dan koneksi database.',
      auth: 'Public (No Auth Required)',
      response: {
        status: 'ok',
        service: 'xharely-pos-backend',
        database: 'connected',
        timestamp: '2026-08-18T00:15:00Z'
      }
    }
  ];

  const protectedEndpoints = [
    {
      method: 'GET',
      path: '/api/me',
      title: 'Current User & Merchant Profile',
      description: 'Ambil profil akun yang sedang login dan info outlet yang aktif.',
      auth: 'Bearer Token Required',
      response: {
        user: { id: 'uuid-2', name: 'Budi Santoso', email: 'budi@kopisenja.com', role: 'owner' },
        merchant: { id: 'uuid-1', name: 'Kopi Kenangan Senja', subscription_plan: 'pro' },
        outlet: { id: 'uuid-outlet-1', name: 'Main Outlet', code: 'MRC123-01' }
      }
    },
    {
      method: 'GET',
      path: '/api/products',
      title: 'List All Products',
      description: 'Ambil seluruh produk dengan filter kategori, pencarian nama/SKU, dan pagination.',
      auth: 'Bearer Token Required',
      params: {
        category_id: 'string (optional) - Filter ID kategori',
        search: 'string (optional) - Cari nama / SKU produk',
        page: 'integer (optional) - Nomor halaman'
      },
      response: {
        data: [
          {
            id: 'prod-001',
            name: 'Espresso Single Origin',
            sku: 'ESP-01',
            price: 25000,
            cost_price: 12000,
            stock: 48,
            min_stock: 10,
            category: { id: 'cat-1', name: 'Coffee' }
          }
        ],
        total: 1,
        current_page: 1
      }
    },
    {
      method: 'POST',
      path: '/api/products',
      title: 'Create Product',
      description: 'Tambah item menu / produk baru ke katalog toko.',
      auth: 'Bearer Token Required',
      params: {
        category_id: 'string (required)',
        name: 'string (required) - Nama produk',
        sku: 'string (optional) - Kode barcode / SKU',
        price: 'number (required) - Harga jual',
        cost_price: 'number (optional) - Harga modal HPP',
        stock: 'integer (required) - Stok awal',
        min_stock: 'integer (optional) - Batas minimum peringatan stok'
      },
      response: {
        status: 'success',
        data: { id: 'prod-002', name: 'Caramel Macchiato', price: 35000, stock: 30 }
      }
    },
    {
      method: 'GET',
      path: '/api/products/low-stock',
      title: 'Low Stock Alerts',
      description: 'Dapatkan daftar produk yang stoknya berada di bawah batas minimum.',
      auth: 'Bearer Token Required',
      response: {
        data: [
          { id: 'prod-003', name: 'Susu UHT 1L', stock: 2, min_stock: 5, status: 'low_stock' }
        ]
      }
    },
    {
      method: 'POST',
      path: '/api/products/{id}/add-stock',
      title: 'Quick Restock Product',
      description: 'Tambah kuantitas stok barang secara cepat.',
      auth: 'Bearer Token Required',
      params: {
        quantity: 'integer (required) - Jumlah stok tambahan',
        notes: 'string (optional) - Catatan restok'
      },
      response: {
        status: 'success',
        message: 'Stok berhasil ditambahkan',
        new_stock: 50
      }
    },
    {
      method: 'POST',
      path: '/api/transactions',
      title: 'Create Transaction & POS Checkout',
      description: 'Proses pembayaran kasir untuk pesanan pelanggan.',
      auth: 'Bearer Token Required',
      params: {
        items: 'array of objects (required) - [{ product_id, quantity, price, notes }]',
        payment_method: 'string (required) - cash, qris, debit, transfer',
        cash_amount: 'number (optional) - Jumlah uang tunai dibayarkan',
        customer_id: 'string (optional) - ID pelanggan',
        table_id: 'string (optional) - ID meja (F&B)',
        discount_amount: 'number (optional)'
      },
      response: {
        status: 'success',
        data: {
          id: 'trx-uuid-1',
          invoice_number: 'TRX-260818-001',
          subtotal: 85000,
          total_amount: 94350,
          payment_status: 'paid',
          receipt_url: 'https://api.pos.xharely.com/api/receipt/trx-uuid-1'
        }
      }
    },
    {
      method: 'GET',
      path: '/api/transactions/daily-report',
      title: 'Daily Sales Report',
      description: 'Rekapitulasi total omzet penjualan, jumlah transaksi, dan rincian metode pembayaran hari ini.',
      auth: 'Bearer Token Required',
      response: {
        date: '2026-08-18',
        total_revenue: 3450000,
        total_transactions: 42,
        payment_breakdown: { qris: 1850000, cash: 1200000, debit: 400000 }
      }
    },
    {
      method: 'POST',
      path: '/api/transactions/{id}/send-digital-receipt',
      title: 'Send Digital Receipt',
      description: 'Kirimkan link struk digital ke WhatsApp atau Email pelanggan.',
      auth: 'Bearer Token Required',
      params: {
        channel: 'string (required) - whatsapp atau email',
        target: 'string (required) - Nomor HP 08... atau alamat email'
      },
      response: {
        status: 'success',
        message: 'Struk digital berhasil dikirim.'
      }
    },
    {
      method: 'GET',
      path: '/api/customers',
      title: 'List Customers',
      description: 'Daftar pelanggan toko beserta poin loyalitas dan riwayat kunjungan.',
      auth: 'Bearer Token Required',
      response: {
        data: [
          { id: 'cust-1', name: 'Rina Wijaya', phone: '081298765432', points: 150, total_spent: 850000 }
        ]
      }
    },
    {
      method: 'GET',
      path: '/api/customers/check-phone',
      title: 'Customer Lookup by Phone',
      description: 'Pencarian cepat saat kasir memasukkan nomor HP pelanggan.',
      auth: 'Bearer Token Required',
      params: {
        phone: 'string (required) - Nomor telepon dicari'
      },
      response: {
        found: true,
        customer: { id: 'cust-1', name: 'Rina Wijaya', points: 150 }
      }
    },
    {
      method: 'GET',
      path: '/api/tables',
      title: 'List Tables & Occupancy',
      description: 'Daftar denah meja F&B beserta status ketersediaan real-time.',
      auth: 'Bearer Token Required',
      response: {
        data: [
          { id: 'tbl-1', number: 'Meja 01', capacity: 4, status: 'available', section: 'Indoor' },
          { id: 'tbl-2', number: 'Meja 02', capacity: 2, status: 'occupied' }
        ]
      }
    },
    {
      method: 'POST',
      path: '/api/tables/{id}/occupy',
      title: 'Set Table Occupied',
      description: 'Tandai meja sedang digunakan saat tamu tiba.',
      auth: 'Bearer Token Required',
      params: {
        guest_count: 'integer (optional) - Jumlah tamu'
      },
      response: { status: 'success', message: 'Meja 01 kini terisi' }
    },
    {
      method: 'GET',
      path: '/api/outlets',
      title: 'List Outlets / Branches',
      description: 'Daftar semua cabang outlet toko di bawah akun merchant.',
      auth: 'Bearer Token Required',
      response: {
        data: [
          { id: 'outlet-1', name: 'Kopi Senja - Sudirman', code: 'KS-01', is_active: true }
        ]
      }
    },
    {
      method: 'POST',
      path: '/api/stock-transfers',
      title: 'Request Stock Transfer',
      description: 'Ajukan mutasi / transfer stok produk antar cabang outlet.',
      auth: 'Bearer Token Required',
      params: {
        from_outlet_id: 'string (required) - ID outlet asal',
        to_outlet_id: 'string (required) - ID outlet tujuan',
        items: 'array (required) - [{ product_id, quantity }]',
        notes: 'string (optional)'
      },
      response: {
        status: 'success',
        transfer_id: 'st-uuid-1',
        transfer_status: 'pending_approval'
      }
    },
    {
      method: 'GET',
      path: '/api/subscription',
      title: 'Get Subscription Status',
      description: 'Cek status paket aktif toko dan masa aktif langganan.',
      auth: 'Bearer Token Required',
      response: {
        plan: 'basic',
        status: 'active',
        expires_at: null,
        is_active: true,
        days_remaining: 9999
      }
    },
    {
      method: 'POST',
      path: '/api/subscription/checkout',
      title: 'Create Subscription Payment Invoice',
      description: 'Buat tagihan invoice resmi perpanjangan langganan melalui saluran pembayaran terintegrasi (Virtual Account, QRIS, & Transfer Bank).',
      auth: 'Bearer Token Required',
      params: {
        amount: 'number (required) - Nominal paket langganan',
        plan_code: 'string (optional) - pro_1m, pro_12m, biz_1m',
        return_url: 'string (optional) - URL pengalihan setelah pembayaran berhasil'
      },
      response: {
        success: true,
        reference_id: 'XP-260818-D559',
        payment_url: 'https://payment.xharely.com/pay/inv_XP260818D559',
        total_amount: 119000,
        months: 1
      }
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src="/x-logo.svg" alt="xharely" className="h-9 w-9" />
            <span className="font-bold text-lg text-black">xharely</span>
          </div>
          <button 
            onClick={onBack}
            className="text-gray-700 hover:text-black transition font-medium flex items-center gap-1.5 text-sm"
          >
            ← Back
          </button>
        </nav>
      </header>

      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            {/* Title */}
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold mb-3 text-gray-900">xharely API Documentation</h1>
              <p className="text-gray-600 text-base md:text-lg">
                Complete API reference for all xharely products
              </p>
            </div>

            {/* Product Navigation */}
            <div className="flex justify-center mb-12">
              <div className="bg-white rounded-2xl p-1.5 shadow-sm border border-gray-100 inline-flex">
                <button 
                  onClick={() => setActiveProduct('xharelyPOS')}
                  className={`px-6 py-2.5 rounded-xl font-medium text-sm transition ${
                    activeProduct === 'xharelyPOS' ? 'bg-black text-white shadow-sm' : 'text-gray-600 hover:text-black'
                  }`}
                >
                  xharelyPOS
                </button>
                <button 
                  onClick={() => setActiveProduct('xharelyEvent')}
                  className={`px-6 py-2.5 rounded-xl font-medium text-sm transition ${
                    activeProduct === 'xharelyEvent' ? 'bg-black text-white shadow-sm' : 'text-gray-600 hover:text-black'
                  }`}
                >
                  xharelyEvent
                </button>
              </div>
            </div>

            {/* Content based on active product */}
            {activeProduct === 'xharelyPOS' ? (
              <div>
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Public Endpoints Column */}
                  <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100">
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <h2 className="text-xl md:text-2xl font-bold text-green-600">Public Endpoints</h2>
                        <p className="text-gray-500 text-sm mt-0.5">No authentication required</p>
                      </div>
                      <span className="bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-1 rounded-full">
                        {publicEndpoints.length} Endpoints
                      </span>
                    </div>
                    
                    <div className="space-y-3.5 mt-6">
                      {publicEndpoints.map((endpoint, index) => (
                        <div 
                          key={index} 
                          className="border border-gray-200 rounded-xl p-4 hover:shadow-md hover:border-gray-300 transition cursor-pointer bg-white" 
                          onClick={() => setSelectedEndpoint(endpoint)}
                        >
                          <div className="flex items-center justify-between mb-1.5">
                            <div className="flex items-center gap-2.5 flex-wrap">
                              <span className={`px-2 py-0.5 rounded text-xs font-bold font-mono ${
                                endpoint.method === 'GET' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                              }`}>
                                {endpoint.method}
                              </span>
                              <code className="text-sm font-mono font-semibold text-gray-800">{endpoint.path}</code>
                            </div>
                            <span className="text-gray-400 text-xs">Detail →</span>
                          </div>
                          <p className="text-gray-600 text-xs leading-relaxed">{endpoint.title} - {endpoint.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Protected Endpoints Column */}
                  <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100">
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <h2 className="text-xl md:text-2xl font-bold text-yellow-600">Protected Endpoints</h2>
                        <p className="text-gray-500 text-sm mt-0.5">JWT Bearer token required</p>
                      </div>
                      <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded-full">
                        {protectedEndpoints.length} Endpoints
                      </span>
                    </div>
                    
                    <div className="space-y-3.5 mt-6">
                      {protectedEndpoints.map((endpoint, index) => (
                        <div 
                          key={index} 
                          className="border border-gray-200 rounded-xl p-4 hover:shadow-md hover:border-gray-300 transition cursor-pointer bg-white" 
                          onClick={() => setSelectedEndpoint(endpoint)}
                        >
                          <div className="flex items-center justify-between mb-1.5">
                            <div className="flex items-center gap-2.5 flex-wrap">
                              <span className={`px-2 py-0.5 rounded text-xs font-bold font-mono ${
                                endpoint.method === 'GET' ? 'bg-blue-100 text-blue-800' : 
                                endpoint.method === 'POST' ? 'bg-green-100 text-green-800' :
                                endpoint.method === 'PUT' ? 'bg-yellow-100 text-yellow-800' :
                                'bg-red-100 text-red-800'
                              }`}>
                                {endpoint.method}
                              </span>
                              <code className="text-sm font-mono font-semibold text-gray-800">{endpoint.path}</code>
                            </div>
                            <span className="text-gray-400 text-xs">Detail →</span>
                          </div>
                          <p className="text-gray-600 text-xs leading-relaxed">{endpoint.title} - {endpoint.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Base URL & Auth Guide */}
                <div className="mt-10 bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Base URL</h3>
                  <code className="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg block font-mono text-sm mb-6 border border-gray-200">
                    https://api.pos.xharely.com
                  </code>
                  
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Authentication</h3>
                  <p className="text-gray-600 text-sm mb-3">Sertakan JWT token di header Authorization untuk endpoint terproteksi:</p>
                  <code className="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg block font-mono text-sm border border-gray-200">
                    Authorization: Bearer YOUR_JWT_TOKEN
                  </code>
                </div>
              </div>
            ) : (
              /* xharelyEvent */
              <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100 text-center max-w-2xl mx-auto">
                <div className="text-6xl mb-6">🎉</div>
                <h2 className="text-2xl font-bold mb-3 text-gray-900">xharelyEvent API</h2>
                <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                  Dokumentasi event management API akan segera dirilis bersamaan dengan peluncuran xharelyEvent di Q1 2027.
                </p>
                <div className="bg-gray-50 rounded-xl p-6 text-left border border-gray-100">
                  <h3 className="font-semibold text-sm mb-3 text-gray-900">Fitur yang Akan Hadir:</h3>
                  <ul className="text-xs text-gray-600 space-y-2">
                    <li>• Event creation, ticketing and session management</li>
                    <li>• QR Code E-Ticket generation & gate scanner</li>
                    <li>• Attendee CRM & real-time check-in analytics</li>
                    <li>• Integrated instant payment gateway</li>
                  </ul>
                </div>
              </div>
            )}

            {/* Endpoint Details Modal */}
            {selectedEndpoint && (
              <div 
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" 
                onClick={() => setSelectedEndpoint(null)}
              >
                <div 
                  className="bg-white rounded-2xl p-6 md:p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" 
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex justify-between items-start mb-6 pb-4 border-b border-gray-100">
                    <div>
                      <div className="flex items-center gap-2.5 mb-2 flex-wrap">
                        <span className={`px-2.5 py-1 rounded text-xs font-bold font-mono ${
                          selectedEndpoint.method === 'GET' ? 'bg-blue-100 text-blue-800' :
                          selectedEndpoint.method === 'POST' ? 'bg-green-100 text-green-800' :
                          selectedEndpoint.method === 'PUT' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-red-100 text-red-800'
                        }`}>
                          {selectedEndpoint.method}
                        </span>
                        <code className="text-base font-mono font-bold text-gray-900">{selectedEndpoint.path}</code>
                      </div>
                      <h3 className="text-base font-bold text-gray-900">{selectedEndpoint.title}</h3>
                      <p className="text-gray-600 text-xs mt-1">{selectedEndpoint.description}</p>
                    </div>
                    <button 
                      onClick={() => setSelectedEndpoint(null)} 
                      className="text-gray-400 hover:text-gray-700 text-xl font-bold w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
                    >
                      ✕
                    </button>
                  </div>

                  {selectedEndpoint.auth && (
                    <div className="mb-5">
                      <h4 className="font-semibold text-xs text-gray-700 uppercase tracking-wider mb-2">Authentication</h4>
                      <code className="bg-gray-100 text-gray-800 px-3 py-1.5 rounded-lg text-xs font-mono inline-block border border-gray-200">
                        {selectedEndpoint.auth}
                      </code>
                    </div>
                  )}

                  {selectedEndpoint.params && (
                    <div className="mb-5">
                      <h4 className="font-semibold text-xs text-gray-700 uppercase tracking-wider mb-2">Parameters / Request Body</h4>
                      <div className="bg-gray-50 rounded-xl p-3.5 border border-gray-100 overflow-x-auto">
                        <pre className="text-xs font-mono text-gray-800 leading-relaxed">{JSON.stringify(selectedEndpoint.params, null, 2)}</pre>
                      </div>
                    </div>
                  )}

                  <div>
                    <h4 className="font-semibold text-xs text-gray-700 uppercase tracking-wider mb-2">Response Sample (200 OK)</h4>
                    <div className="bg-gray-50 rounded-xl p-3.5 border border-gray-100 overflow-x-auto">
                      <pre className="text-xs font-mono text-gray-800 leading-relaxed">{JSON.stringify(selectedEndpoint.response, null, 2)}</pre>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white pt-16 pb-12 border-t border-gray-100 mt-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12 border-b border-gray-100">
            {/* Brand Column */}
            <div className="space-y-4">
              <img src="/x-logo-text.svg" alt="xharely - menghubungkan ide membangun solusi digital" className="h-8 md:h-10 w-auto" />
              <p className="text-gray-600 text-sm leading-relaxed max-w-sm">
                Menghubungkan ide inovatif dengan solusi digital terbaik untuk mempercepat pertumbuhan dan efisiensi bisnis Anda.
              </p>
            </div>

            {/* Office Address Column */}
            <div className="space-y-3">
              <h3 className="text-sm font-bold uppercase tracking-wider text-black">Alamat Kantor</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Jl. Kayangan, Tangkerang Barat, Marpoyan Damai, Pekanbaru, Riau, Indonesia (28282)
              </p>
            </div>

            {/* Contact Column */}
            <div className="space-y-3">
              <h3 className="text-sm font-bold uppercase tracking-wider text-black">Hubungi Kami</h3>
              <ul className="space-y-2.5 text-sm text-gray-600">
                <li>
                  <a 
                    href="https://wa.me/6285121210306" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center gap-2.5 text-gray-700 hover:text-green-600 transition font-medium"
                  >
                    <svg className="w-5 h-5 text-green-500 fill-current flex-shrink-0" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                    </svg>
                    <span>WhatsApp: +62 851-2121-0306</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:contact@xharely.com" 
                    className="inline-flex items-center gap-2.5 text-gray-700 hover:text-black transition font-medium"
                  >
                    <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span>Email: contact@xharely.com</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 text-center md:text-left text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} PT Xharely Teknologi Indonesia. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ApiDocs;